import {
  ChimesService,
  ClockStationService,
  ClockStation_SetChimesVolumeModel,
  UpdateChimesTechnicalInformation,
  WriteChimes,
  WriteChimesTime,
} from "../api";
import {ChimesTime, ClockChimeSettingsParams} from "../models/ChimeSettingsSection.model";

type ClockChimeParamsPayload = {
  mode: number;
  scheme: number;
  christmas: boolean;
  chimesSoundLevel: number;
};

export const ClockChimeSettingsApi =  {

  // Получение параметров боя
  getClockChimeParams: async (id: string): Promise<ClockChimeSettingsParams> => {
    return ChimesService.getApiChimesInfo(id);
  },

  // Обновление параметров боя
  updateClockChimeParams: async (id: string, payload: ClockChimeParamsPayload): Promise<boolean> => {
    const requestBody: WriteChimes = {
      mode: payload.mode,
      scheme: payload.scheme,
      christmas: payload.christmas,
    };
    await ChimesService.postApiChimes(id, requestBody);
    return true;
  },

  // Обновление времени боя
  updateClockChimeTime: async (id: string, payload: ChimesTime): Promise<boolean> => {
    const requestBody: WriteChimesTime = payload;
    await ChimesService.postApiChimesTime(id, requestBody);
    return true;
  },

  // Получение описания
  getClockChimeDescription: async (id: string): Promise<Record<string, string>> => {
    return ChimesService.getApiChimesDescriptionTechnical(id);
  },

  // Обновление описания
  updateClockChimeDescription: async (id: string, payload: Record<string, string>): Promise<boolean> => {
    const requestBody: UpdateChimesTechnicalInformation = {
      technicalDescription: payload.technicalDescription,
    };
    await ChimesService.postApiChimesDescriptionTechnical(id, requestBody);
    return true;
  },

  // Обновление громкости
  updateClockChimeVolume: async (id: string, volume: number): Promise<boolean> => {
    const requestBody: ClockStation_SetChimesVolumeModel = {volume};
    await ClockStationService.postApiClockStationChimesVolume(id, requestBody);
    return true;
  },

  // Тест боя
  clockChimeTest: async (id: string): Promise<boolean> => {
    await ClockStationService.postApiClockStationChimesTest(id);
    return true;
  },

  // Тест проигрыша
  clockLossTest: async (id: string): Promise<boolean> => {
    await ClockStationService.postApiClockStationMelodyTest(id);
    return true;
  },


}
